import { Panel } from '../../../../components/panels/Panel';
import { InputSelect } from '../../../../components/forms/inputs/InputSelect';
import { useJournal } from '../../../../contexts/JournalContext';
import { useOrgData } from '../../../../contexts/OrgDataContext';
import { ServiceStatusIndicator } from '../../../../components/others/ServiceStatusIndicator';
import { Calendar } from '../../../../components/others/Calendar';
import { JOURNAL_DISPLAY_OPTIONS } from "../../../../services/journal/journal-service";
import { JournalLogs } from "./JournalLogs";

export const JournalMainPanel = () => {
  const {
    workshops, workshopSelected, setWorkshopSelected,
    workstations, workstationSelected, setWorkstationSelected, isWorkstationDataLoading
  } = useOrgData();

  const { selectedDisplayOption, setSelectedDisplayOption, isLogsProcessing, setIsLogsProcessing } = useJournal();

  const handleWorkshopChange = (item) => {
    setIsLogsProcessing(true);
    setWorkshopSelected(item);
  };

  const handleWorkstationChange = (selectedWorkstation) => {
    console.log('CHANGE');
    setIsLogsProcessing(true);
    setWorkstationSelected(selectedWorkstation);
  };

  const inputDisabled = isWorkstationDataLoading || isLogsProcessing;

  return (
    <div className='flex flex-col w-full h-full overflow-hidden'>
      <Panel category='main' title='ACTIVITY LOG'>
        <div className='flex flex-col w-full h-full'>
          <div className='flex items-center w-full'>
            <div className='w-1/4'>
              <InputSelect
                items={workshops}
                onChange={handleWorkshopChange}
                itemToString={(item) => item?.name}
                defaultValue={workshopSelected}
                disabled={inputDisabled}
              />
            </div>
            <div className='w-1/4 mx-4'>
              <InputSelect
                items={workstations}
                onChange={handleWorkstationChange}
                itemToString={(item) => item?.name}
                defaultValue={workstationSelected}
                disabled={inputDisabled}
              />
            </div>
            {
              process.env.REACT_APP_PRODUCTION_MODE !== '0' &&
                <div className='w-1/4'>
                  <InputSelect
                    items={JOURNAL_DISPLAY_OPTIONS}
                    onChange={(item) => setSelectedDisplayOption(item)}
                    itemToString={(item) => item?.name}
                    defaultValue={selectedDisplayOption}
                    disabled={isLogsProcessing}
                  />
                </div>
            }
            <Calendar useContext={useJournal} contextType="journal" />
            <span className="ml-auto">
              <ServiceStatusIndicator view="prod" />
            </span>
          </div>
          <div className='relative flex-1 w-full pt-6 overflow-hidden'>
            <JournalLogs/>
          </div>
        </div>
      </Panel>
    </div>
  );
};
